import script from "./QuickpaySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettings.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettings.vue?vue&type=style&index=0&id=1b05cd41&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b05cd41"]])

export default __exports__